import styled, { css } from 'styled-components';
import type { Colors } from 'styled-components';

import { th, getColor, getSpace } from '@yoweb/ui/styles/utils/theme';

export type AlertDotProps = {
  border?: boolean;
  borderColor?: keyof Colors | 'transparent';
  color?: keyof Colors | 'transparent';
};

export const AlertDot = styled.div<AlertDotProps>`
  height: ${getSpace('small3')};
  width: ${getSpace('small3')};
  min-width: ${getSpace('small3')};
  border-radius: 50%;
  background-color: ${({ color }) =>
    color === 'transparent' ? 'transparent' : getColor(color ?? 'warning')};

  ${({ border, borderColor }) =>
    border &&
    css`
      border: 2px solid ${th.getColor(borderColor ?? 'sandLight')};
      box-sizing: content-box;
    `}
`;
